import React from "react";
import { Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import AuthAPI from "../../../../services/auth-api";
import { storeToken, storeUserId } from "../../../../utils/storage";
import { addUserInfo, handleUserLoggedIn } from "../../../../redux/slices/userSlice";
import { loginOtpValidation } from "../../../Auth/Auth.validation";

export default function OTPForm() {
  const location = useLocation();
  const dispatch = useDispatch();

  const { tempValues, data } = location.state || {};

  const { registerVerifyOTP } = new AuthAPI();

  const initialValues = {
    otp: "",
  };

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={loginOtpValidation}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) => {
          setSubmitting(true);
          setTimeout(async () => {
            const res = await registerVerifyOTP(tempValues, data, values);

            // console.log("res---------", res);

            if (res.ok) {
              const { token, ...userData } = res.data;
              storeToken(res.data.token);
              storeUserId(userData.id);
              dispatch(addUserInfo(userData));
              dispatch(handleUserLoggedIn(true));
              window.location.href = "/";
            } else {
              setFieldError("otp", res.err);
            }

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid size={12}>
                <TextField
                  fullWidth
                  autoComplete="off"
                  size="small"
                  name="otp"
                  label="Enter OTP"
                  variant="outlined"
                  helperText={touched.otp && errors.otp}
                  error={touched.otp && errors.otp}
                  value={values.otp}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Grid>

              <Grid size={12} textAlign="center">
                <Button
                  color="primary"
                  // disabled={true}
                  variant="contained"
                  fullWidth
                  type="submit"
                  size="large"
                  endIcon={
                    isSubmitting && <CircularProgress size="1.4rem" style={{ color: "#ffffff", marginLeft: 6 }} />
                  }
                  sx={{
                    "&.Mui-disabled": {
                      color: "#333333",
                      background: "#ddddddd",
                    },
                    width: 200,
                    marginTop: 3,
                    marginBottom: 2,
                    textTransform: "capitalize",
                  }}
                >
                  Request OTP
                </Button>

                <Typography typography="body2">
                  OTP sent to +91 {data?.phoneNo} and {data?.email}
                </Typography>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
